import { render, staticRenderFns } from "./wrapper-modal-component.vue?vue&type=template&id=4f34d70a&scoped=true&"
import script from "./wrapper-modal-component.vue?vue&type=script&lang=ts&"
export * from "./wrapper-modal-component.vue?vue&type=script&lang=ts&"
import style0 from "./wrapper-modal-component.vue?vue&type=style&index=0&id=4f34d70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34d70a",
  null
  
)

export default component.exports